import { Grid, Slider } from "@mui/material";
import { PricesStorage, PriceTier } from "e.sic-platform.webclient/src/services/shop/PricesStorage";
import { observer } from "mobx-react-lite";
import { useCallback, useMemo } from "react";
import { formatEuro } from "e.sic-platform.webclient/src/services/shop/formatEuro";

// Tiers and the order are in euro-cents; the slider runs in whole euros so its position array
// stays small (one entry per euro, not per cent).
const CENTS = 100;

export default observer(function PriceStepper(props: {pricesStorage: PricesStorage, coins: number}) {
    const {coins, pricesStorage} = props;
    const maximumEuros = Math.floor(pricesStorage.maximumCoins / CENTS);
    const minimumEuros = Math.floor(pricesStorage.minimumCoins / CENTS);
    var steps = maximumEuros / pricesStorage.totalTiers;

    const closest = (array: any[], value: number) => {
        return array.reduce((prev, next) =>
            Math.abs(next - value) < Math.abs(prev - value) ? next : prev
        );
    };

    const scale = useCallback((value: number) => {
        if (value === 0) return 0;
        var index = Math.floor(value / steps);
        var tier = pricesStorage.prices[index];
        if (tier) {
            var quotient = value / steps % 1;
            var diff = (tier.maximum - tier.minimum) / CENTS;
            var newValue = quotient * diff + tier.minimum / CENTS;
            return Math.round(newValue + 1);
        } else return 0
    }, [steps])

    const values = useMemo(() => Array.from(Array(maximumEuros)).map((value: number, index: number) => scale(index)), []);

    const value = useMemo(() => values.indexOf(closest(values, coins / CENTS)), [coins, values]);

    const toEuros = (euros: number) => formatEuro(euros * CENTS);

    var markLabels = [...pricesStorage.prices.map((pt: PriceTier) => {return {value: pt.id * steps, label: toEuros((pt.maximum + 1) / CENTS)}}), {value: 0, label: 0}];
    var marks = markLabels.map((value: any) => value.value);
    pricesStorage.prices.forEach((pt: PriceTier) => markLabels.push({value: (pt.id - 1) * steps + (steps / 2), label: pt.discount + "%"}))

    return (
        <>
            <Grid item xs={12} className="centered">
                <Slider sx={{ '& .MuiSlider-markLabel': {
                     top: -15, // Moves the marks above the slider
                }}} 
                disabled 
                valueLabelFormat={(v: number) => toEuros(scale(v))} min={minimumEuros} max={maximumEuros} value={marks} marks={markLabels}/>
            </Grid>
            <Grid item xs={12} className="centered">
                <Slider valueLabelFormat={(v: number) => toEuros(scale(v))} valueLabelDisplay="on" value={value} min={minimumEuros} max={maximumEuros - 1} />
            </Grid>
        </>
    )
})